import { AxiosError } from 'axios'

import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'
import { httpClient } from 'shared/lib'

import { BlockDetailsType, CompanySettingsType } from './types'

export function fetchCompanyData() {
   let errMessage = ''

   return httpClient
      .get<CompanySettingsType>('companies')
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('COMPANY fetchCompanyDetails service', errMessage, 'error')
         throw error
      })
}

export function fetchBlockDetails() {
   let errMessage = ''

   return httpClient
      .get<BlockDetailsType>('companies/status')
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('COMPANY fetchBlockDetails service', errMessage, 'error')
         throw error
      })
}

export function saveCompanyData(payload: CompanySettingsType) {
   let errMessage = ''

   return httpClient
      .patch<Result>(`companies`, payload)
      .then((res) => ({ status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('COMPANY saveCompanyDetails service', errMessage, 'error')
         throw error
      })
}
